import React from "react";
import "../style/PontajItem.css";

const IstoricAnualPontajTehnicianItem = ({ istoricAnualPontaj }) => {
  return (
    <div
      className={`pontaj_istoric_item_wrapper pontajBackground`}
    >
      <div className={`istoric_salariu_item_month`}>
        <div className={`ml-2`} style={{ color: "white", fontSize: "25px" }}>
          {new Date(istoricAnualPontaj.date).getFullYear()}
        </div>
      </div>
      <div className={`istoric_salariu_item`} style={{ justifyContent: "space-around" }}>
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "center"}}>
          <div>
            Zile concediu luate: {" "}
              {(istoricAnualPontaj &&
                istoricAnualPontaj.concediu !== 0 &&
                istoricAnualPontaj.concediu) || 0}</div>
                
            <div style={{marginLeft: "15px" }}>
              Ramase: {" "}
              {(istoricAnualPontaj &&
                istoricAnualPontaj.concediu !== 0 && (() => {
                  return 21 - istoricAnualPontaj.concediu;
                })()) || 21
              }
          </div>
        </div>
      </div>
      <div className={`istoric_salariu_item`} style={{ justifyContent: "space-around" }}>
          <div>
            ZL:{" "}
            {istoricAnualPontaj &&
              istoricAnualPontaj.zileLibere !== 0 &&
              istoricAnualPontaj.zileLibere}
          </div>
        <div>
          CM:{" "}
          {istoricAnualPontaj &&
            istoricAnualPontaj.medical !== 0 &&
            istoricAnualPontaj.medical}
        </div>
        <div>
          AbN:{" "}
          <span>
            {istoricAnualPontaj &&
              istoricAnualPontaj.absenteNemotivate !== 0 &&
              istoricAnualPontaj.absenteNemotivate}
          </span>
        </div>
      </div>

    </div>
  );
};

export default IstoricAnualPontajTehnicianItem;